
define(function(){
	const GenericCollection = require('civicsBase/generic_collection');

	var instTypeParse = function (data) {
		for (var i = 0; i < data.length; i++) {
			switch(data[i].type.toLowerCase()) {
				case 'building':
					data[i].instrumentType = 'BuildingApplication';
					break;
				case 'businesslicense':
					data[i].instrumentType = 'BusinessLicense';
					break;
				case 'codeenforcement':
					data[i].instrumentType = 'Case';
					break;
				case 'planning':
					data[i].instrumentType = 'PlanningApplication';
					break;
				case 'project':
					data[i].instrumentType = 'ProjectApplication';
					break;
				case 'trade':
					data[i].instrumentType = 'TradeLicense';
					break;
				case 'use':
					data[i].instrumentType = 'UseApplication';
					break;
				default:
					data[i].instrumentType = 'ServiceRequest';
					break;
			}
		}
		return data;
	}

	return GenericCollection.extend({
		dataTypeContext : [{
			type: 'Building',
			url: 'cdr/applicationtypes/Building',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'BusinessLicense',
			url: 'cdr/applicationtypes/BusinessLicense',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'CodeEnforcement',
			url: 'cdr/applicationtypes/CodeEnforcement',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'Planning',
			url: 'cdr/applicationtypes/Planning',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'Project',
			url: 'cdr/applicationtypes/Project',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'TradeLicense',
			url: 'cdr/applicationtypes/TradeLicense',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		}, {
			type: 'Use',
			url: 'cdr/applicationtypes/Use',
			select:['id','showInPortal','code','description','portaldescription'],
			collectionParse: instTypeParse
		},{
			type: 'ServiceRequest',
			url: 'crm/setup/servicerequesttypes',
			select:['id','showInPortal','type','description','portaldescription'],
			collectionParse: instTypeParse
		}]
	});
});
